// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

const icons = {
	IconDashboard,
	IconDeviceAnalytics,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const SalesTracking = {
	id: 'SalesTracking',
	title: <FormattedMessage id="sales-tracking" />,
	icon: icons.IconDashboard,
	type: 'group',
	children: [
		{
			id: 'salesTracking',
			title: <FormattedMessage id="sales-tracking" />,
			type: 'item',
			url: '/sales-tracking',
			icon: SalesTrackingIcon,
			breadcrumbs: false,
		},
		{
			id: 'salesTrackingGlossary',
			title: <FormattedMessage id="glossary" />,
			type: 'item',
			url: '/sales-tracking/glossary',
			icon: GlossaryIcon,
			breadcrumbs: false,
		},
	],
};

export default SalesTracking;

function SalesTrackingIcon() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>sales tracking</title>

			<path
				d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function GlossaryIcon() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>glossary</title>

			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.14282 19.9286V3.85714C2.14282 2.83417 2.5492 1.85309 3.27255 1.12973C3.99591 0.406376 4.97699 0 5.99996 0L18 0C19.0229 0 20.004 0.406376 20.7274 1.12973C21.4507 1.85309 21.8571 2.83417 21.8571 3.85714V17.1429C21.8571 17.4839 21.7216 17.8109 21.4805 18.052C21.2394 18.2931 20.9124 18.4286 20.5714 18.4286H20.1428V21.4286H20.5714C20.9124 21.4286 21.2394 21.564 21.4805 21.8051C21.7216 22.0463 21.8571 22.3733 21.8571 22.7143C21.8571 23.0553 21.7216 23.3823 21.4805 23.6234C21.2394 23.8645 20.9124 24 20.5714 24H6.21425C5.13444 24 4.09886 23.571 3.33532 22.8075C2.57178 22.044 2.14282 21.0084 2.14282 19.9286ZM17.5714 18.4286H6.21425C5.81643 18.4286 5.4349 18.5866 5.15359 18.8679C4.87229 19.1492 4.71425 19.5307 4.71425 19.9286C4.71425 20.3264 4.87229 20.7079 5.15359 20.9892C5.4349 21.2705 5.81643 21.4286 6.21425 21.4286H17.5714V18.4286ZM18.5314 8.18057C18.4591 8.04107 18.3499 7.92412 18.2157 7.8425C18.0814 7.76087 17.9274 7.7177 17.7703 7.71771H13.8034C13.5761 7.71771 13.358 7.80802 13.1973 7.96877C13.0366 8.12951 12.9462 8.34753 12.9462 8.57486C12.9462 8.80219 13.0366 9.0202 13.1973 9.18095C13.358 9.34169 13.5761 9.432 13.8034 9.432H16.1142L12.8554 14.0331C12.7645 14.1614 12.7107 14.3122 12.6998 14.469C12.6889 14.6259 12.7213 14.7827 12.7935 14.9223C12.8657 15.0619 12.9749 15.179 13.1092 15.2607C13.2435 15.3425 13.3976 15.3857 13.5548 15.3857H18.0188C18.2461 15.3857 18.4642 15.2954 18.6249 15.1347C18.7857 14.9739 18.876 14.7559 18.876 14.5286C18.876 14.3012 18.7857 14.0832 18.6249 13.9225C18.4642 13.7617 18.2461 13.6714 18.0188 13.6714H15.2125L18.4697 9.07029C18.5609 8.94209 18.6151 8.79126 18.6262 8.63433C18.6374 8.4774 18.6035 8.32041 18.5314 8.18057ZM9.96854 4.50857C9.86535 4.20157 9.66837 3.93471 9.40539 3.74566C9.14241 3.55661 8.8267 3.45491 8.50282 3.45491C8.17894 3.45491 7.86324 3.55661 7.60025 3.74566C7.33727 3.93471 7.14029 4.20157 7.03711 4.50857L5.87654 7.98857L5.86454 8.02629L5.20797 9.99086C5.17228 10.0978 5.15801 10.2107 5.16597 10.3232C5.17392 10.4356 5.20395 10.5454 5.25433 10.6462C5.30471 10.7471 5.37447 10.837 5.45961 10.9109C5.54474 10.9848 5.6436 11.0412 5.75054 11.0769C5.9665 11.1489 6.20224 11.1322 6.40591 11.0305C6.50675 10.9801 6.59668 10.9104 6.67057 10.8252C6.74446 10.7401 6.80085 10.6412 6.83654 10.5343L7.29939 9.13543H9.70282L10.1691 10.5343C10.2412 10.75 10.396 10.9283 10.5995 11.0299C10.803 11.1315 11.0385 11.1481 11.2543 11.076C11.47 11.0039 11.6483 10.8491 11.7498 10.6456C11.8514 10.4421 11.868 10.2066 11.796 9.99086L11.1411 8.02629L11.1274 7.98857L9.96854 4.50857ZM7.86854 7.41943L8.49939 5.53029L9.12854 7.41943H7.86854Z"
				fill="currentColor"
			/>
		</svg>
	);
}
